import React, { useState } from "react";
import PropTypes from "prop-types";
import Masonry from "react-masonry-component";
import Image from "./image";
import "./masonry.css";

const masonryOptions = {
  fitWidth: true,
  columnWidth: 300,
  gutter: 8,
  itemSelector: ".photo-item",
};

const MasonryImageGrid = ({ photos }) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  function addActiveClass(index) {
    index === activeIndex ? setActiveIndex(-1) : setActiveIndex(index);
  }
  return (
    <>
      <Masonry
        className={"photo-list"}
        elementType={"div"}
        options={masonryOptions}
        disableImagesLoaded={false}
        updateOnEachImageLoad={false}
      >
        {photos.map((photo, index) => (
          <li
            onClick={() => addActiveClass(index)}
            key={index}
            className={`photo-item`}
          >
            <Image
              src={photo.imageUrl}
              image={photo.image}
              key={index}
              data-sal="slide-up"
              data-sal-duration="200"
              data-sal-delay="300"
              data-sal-easing="ease"
            />
            {activeIndex === index && (
              <Image
                src={photo.imageUrl}
                image={photo.image}
                key={index}
                className="fullscreen"
                onClick={() => addActiveClass(-1)}
              />
            )}
          </li>
        ))}
      </Masonry>
    </>
  );
};

export default MasonryImageGrid;

MasonryImageGrid.propTypes = {
  photos: PropTypes.array,
};

MasonryImageGrid.defaultProps = {
  photos: [],
};
